import { __extends } from "tslib";
import { BitmapImage2D, RTTBufferManager } from "@awayjs/stage";
import { Filter3DRenderer } from "./Filter3DRenderer";
import { RendererBase } from "./RendererBase";
/**
 * The DefaultRenderer class provides the default rendering method. It renders the scene graph objects using the
 * materials assigned to them.
 *
 * @class away.render.DefaultRenderer
 */
var DefaultRenderer = /** @class */ (function (_super) {
    __extends(DefaultRenderer, _super);
    /**
     * Creates a new DefaultRenderer object.
     *
     * @param antiAlias The amount of anti-aliasing to use.
     * @param renderMode The render mode to use.
     */
    function DefaultRenderer(renderGroup, partition, pool) {
        var _this = _super.call(this, renderGroup, partition, pool) || this;
        _this._pRttBufferManager = RTTBufferManager.getInstance(_this._stage);
        _this._depthRenderer = renderGroup.depthRenderGroup.getRenderer(partition);
        _this._distanceRenderer = renderGroup.distanceRenderGroup.getRenderer(partition);
        return _this;
    }
    Object.defineProperty(DefaultRenderer.prototype, "antiAlias", {
        get: function () {
            return this._stage.antiAlias;
        },
        set: function (value) {
            this._stage.antiAlias = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultRenderer.prototype, "depthPrepass", {
        /**
         *
         */
        get: function () {
            return this._depthPrepass;
        },
        set: function (value) {
            this._depthPrepass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultRenderer.prototype, "filters3d", {
        /**
         *
         * @returns {*}
         */
        get: function () {
            return this._filter3DRenderer ? this._filter3DRenderer.filters : null;
        },
        set: function (value) {
            if (value && value.length == 0)
                value = null;
            if (this._filter3DRenderer && !value) {
                this._filter3DRenderer.dispose();
                this._filter3DRenderer = null;
            }
            else if (!this._filter3DRenderer && value) {
                this._filter3DRenderer = new Filter3DRenderer(this._stage);
                this._filter3DRenderer.filters = value;
            }
            if (this._filter3DRenderer) {
                this._filter3DRenderer.filters = value;
                this._requireDepthRender = this._filter3DRenderer.requireDepthRender;
            }
            else {
                this._requireDepthRender = false;
                if (this._depthRender) {
                    this._depthRender.dispose();
                    this._depthRender = null;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    DefaultRenderer.prototype.enterNode = function (node) {
        var enter = _super.prototype.enterNode.call(this, node);
        if (enter && node.boundsVisible)
            this.applyEntity(node.getBoundsPrimitive(this._renderGroup.pickGroup));
        return enter;
    };
    DefaultRenderer.prototype.render = function (enableDepthAndStencil, surfaceSelector, mipmapSelector, maskConfig) {
        if (enableDepthAndStencil === void 0) { enableDepthAndStencil = true; }
        if (surfaceSelector === void 0) { surfaceSelector = 0; }
        if (mipmapSelector === void 0) { mipmapSelector = 0; }
        if (maskConfig === void 0) { maskConfig = 0; }
        if (!this._stage.recoverFromDisposal()) { //if context has Disposed by the OS,don't render at this frame
            return;
        }
        if (this._requireDepthRender)
            this._renderSceneDepthToTexture();
        if (this._depthPrepass)
            this._renderDepthPrepass();
        if (this._filter3DRenderer) { //TODO
            this._view.target = this._filter3DRenderer.getMainInputTexture(this._stage);
            _super.prototype.render.call(this, enableDepthAndStencil, surfaceSelector, mipmapSelector);
            this._filter3DRenderer.render(this._stage, this._view.projection, this._depthRender);
        }
        else {
            //this._view.target = null;
            _super.prototype.render.call(this, enableDepthAndStencil, surfaceSelector, mipmapSelector, maskConfig);
        }
        if (!maskConfig)
            this._view.present();
    };
    DefaultRenderer.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._pRttBufferManager.dispose();
        this._pRttBufferManager = null;
        this._depthRenderer.onClear(event);
        this._distanceRenderer.onClear(event);
        this._depthRenderer = null;
        this._distanceRenderer = null;
        this._depthRender = null;
    };
    /**
     *
     */
    DefaultRenderer.prototype._renderDepthPrepass = function () {
        this._depthRenderer.disableColor = true;
        this._depthRenderer.view.projection = this._view.projection;
        if (this._filter3DRenderer) {
            this._depthRenderer.view.target = this._filter3DRenderer.getMainInputTexture(this._stage);
            this._depthRenderer.render();
        }
        else {
            this._depthRenderer.view.target = null;
            this._depthRenderer.render();
        }
        this._depthRenderer.disableColor = false;
    };
    /**
     *
     */
    DefaultRenderer.prototype._renderSceneDepthToTexture = function () {
        if (this._depthTextureDirty || !this._depthRender)
            this.initDepthTexture(this._stage.context);
        this._depthRenderer.render();
    };
    /**
     *
     */
    DefaultRenderer.prototype.initDepthTexture = function (context) {
        this._depthTextureDirty = false;
        if (this._depthRender)
            this._depthRender.dispose();
        this._depthRender = new BitmapImage2D(this._pRttBufferManager.textureWidth, this._pRttBufferManager.textureHeight);
        this._depthRenderer.view.target = this._depthRender;
        this._depthRenderer.view.projection = this._view.projection;
    };
    return DefaultRenderer;
}(RendererBase));
export { DefaultRenderer };
